'use strict';

const Pitch = {
  init(payload, done) {
    const $pitchContainer = document.querySelector('#deal-pitch');

    if (!$pitchContainer) {
      return null;
    }

    window.DealEventPipe.on('goodsOptionUpdate', ({ pitchHtml }) => {
      if (typeof pitchHtml !== 'undefined' && pitchHtml !== null) {
        $pitchContainer.innerHTML = pitchHtml;
      }
    });
    return done();
  },
};

module.exports = Pitch;
